(function () {
  document.querySelectorAll('[data-pbnk-preview]').forEach(function (root) {
    var api = String(root.dataset.apiBase || '').replace(/\/$/, '');
    var form = root.querySelector('[data-preview-form]');
    var list = root.querySelector('[data-photo-list]');
    var template = root.querySelector('[data-photo-template]');
    var addButton = root.querySelector('[data-add-photo]');
    var email = form.querySelector('[name="email"]');
    var emailConfirm = form.querySelector('[name="email_confirm"]');
    var emailMatch = form.querySelector('[data-email-match]');
    var nonce = form.querySelector('[data-request-nonce]');
    var copy = {
      photo: root.dataset.labelPhoto || 'Photo',
      choosePhoto: root.dataset.labelChoosePhoto || 'Choose a photo',
      changePhoto: root.dataset.labelChangePhoto || 'Choose another photo',
      emailMatch: root.dataset.labelEmailMatch || 'The email addresses match.',
      emailMismatch: root.dataset.labelEmailMismatch || 'The email addresses must match.',
      uploading: root.dataset.labelUploading || 'Uploading…',
      submit: root.dataset.labelSubmit || 'Send preview request',
      submitError: root.dataset.labelSubmitError || 'Your preview request could not be sent.',
      reference: root.dataset.labelReference || 'Request'
    };

    function createNonce() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        return Array.prototype.map.call(bytes, function (value) { return value.toString(16).padStart(2, '0'); }).join('');
      }
      return String(Date.now()) + '-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
    }
    nonce.value = createNonce();

    function selectedColors(row) {
      return Array.from(row.querySelectorAll('[data-select="colors"] [aria-pressed="true"]')).map(function(b){return Number(b.dataset.choice);});
    }
    function optionCount(row) { return row.querySelector('[data-product]').value==='diamond'?1:selectedColors(row).length; }
    function summary() {
      var rows=Array.from(list.querySelectorAll('.pbnk-photo'));
      rows.forEach(function(row){
        var count=optionCount(row);
        row.querySelector('[data-variant-count]').textContent=(root.dataset.multiCount||"We'll prepare {count} preview option(s) from this photo.")
          .replace('{count}',String(count)).replace(/option\(s\)/g,count===1?'option':'options');
      });
      var options=rows.reduce(function(n,row){return n+optionCount(row);},0);
      root.querySelector('[data-variant-summary]').textContent=(root.dataset.multiSummary||'{photos} original photo(s) · {options} preview option(s)')
        .replace('{photos}',String(rows.length)).replace('{options}',String(options))
        .replace(/photo\(s\)/g,rows.length===1?'photo':'photos')
        .replace(/option\(s\)/g,options===1?'option':'options');
      var hasPainting=rows.some(function(row){return row.querySelector('[data-product]').value==='pbn';});
      var hasDiamond=rows.some(function(row){return row.querySelector('[data-product]').value==='diamond';});
      var explanation=hasPainting&&hasDiamond?'mixed':hasDiamond?'diamond':'pbn';
      root.querySelectorAll('[data-how-panel]').forEach(function(panel){panel.hidden=panel.dataset.howPanel!==explanation;});
    }

    function renumber() {
      var rows = list.querySelectorAll('.pbnk-photo');
      rows.forEach(function (row, index) {
        row.querySelector('[data-photo-title]').textContent = copy.photo + ' ' + (index + 1);
        row.querySelector('[data-remove-photo]').classList.toggle('pbnk-hidden', rows.length === 1);
      });
      addButton.classList.toggle('pbnk-hidden', rows.length >= 3);
      summary();
    }

    function bindChoiceGroup(row, group) {
      var select = row.querySelector('[data-' + group.dataset.select + ']');
      if (!select) return;
      var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-choice]'));
      if (group.dataset.select === 'colors') {
        buttons.forEach(function(button){
          button.addEventListener('click',function(){
            var wasSelected=button.getAttribute('aria-pressed')==='true';
            if(wasSelected && selectedColors(row).length===1){
              row.querySelector('[data-variant-count]').textContent=root.dataset.multiMin||'Keep at least one color option selected.';
              return;
            }
            button.setAttribute('aria-pressed',wasSelected?'false':'true');
            button.classList.toggle('is-selected',!wasSelected);
            select.value=String(selectedColors(row)[0]);
            summary();
          });
        });
        return;
      }
      function selectValue(value) {
        select.value = value;
        buttons.forEach(function (button) {
          var selected = button.dataset.choice === value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      buttons.forEach(function (button) {
        button.addEventListener('click', function () { selectValue(button.dataset.choice); });
      });
      selectValue(select.value);
    }

    function addPhoto() {
      if (list.children.length >= 3) return;
      var row = template.content.firstElementChild.cloneNode(true);
      var product = row.querySelector('[data-product]');
      var colorsPanel = row.querySelector('[data-colors-panel]');
      var stonesPanel = row.querySelector('[data-stones-panel]');
      var upload = row.querySelector('[name="photos[]"]');
      var preview = row.querySelector('[data-upload-preview]');
      var uploadIcon = row.querySelector('[data-upload-icon]');
      var uploadName = row.querySelector('[data-upload-name]');
      var uploadAction = row.querySelector('[data-upload-action]');
      var previewUrl = '';

      function syncProduct() {
        var diamond = product.value === 'diamond';
        colorsPanel.classList.toggle('pbnk-hidden', diamond);
        stonesPanel.classList.toggle('pbnk-hidden', !diamond);
        summary();
      }
      product.addEventListener('change', syncProduct);
      row.querySelectorAll('[data-choice-group]').forEach(function (group) { bindChoiceGroup(row, group); });
      upload.addEventListener('change', function () {
        var file = upload.files && upload.files[0] ? upload.files[0] : null;
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        previewUrl = '';
        uploadName.textContent = file ? file.name : copy.choosePhoto;
        uploadAction.textContent = file ? copy.changePhoto : copy.choosePhoto;
        preview.classList.add('pbnk-hidden');
        uploadIcon.classList.remove('pbnk-hidden');
        preview.removeAttribute('src');
        if (file && /^image\//i.test(file.type)) {
          previewUrl = URL.createObjectURL(file);
          preview.src = previewUrl;
          preview.classList.remove('pbnk-hidden');
          uploadIcon.classList.add('pbnk-hidden');
        }
      });
      row.querySelector('[data-remove-photo]').addEventListener('click', function () {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        row.remove();
        renumber();
      });
      list.appendChild(row);
      syncProduct();
      renumber();
    }

    function checkEmails() {
      if (!email.value && !emailConfirm.value) { emailMatch.textContent = ''; return false; }
      var match = email.value.length > 0 && email.value.trim().toLowerCase() === emailConfirm.value.trim().toLowerCase();
      emailMatch.textContent = match ? copy.emailMatch : copy.emailMismatch;
      emailMatch.className = 'pbnk-help ' + (match ? 'is-ok' : 'is-error');
      return match;
    }
    addButton.addEventListener('click', addPhoto);
    email.addEventListener('input', checkEmails);
    emailConfirm.addEventListener('input', checkEmails);
    addPhoto();

    root.querySelectorAll('[data-quality-image]').forEach(function (button) {
      button.addEventListener('click', function () {
        var lightbox = root.querySelector('[data-quality-lightbox]');
        lightbox.querySelector('[data-quality-lightbox-image]').src = button.dataset.qualityImage;
        lightbox.classList.remove('pbnk-hidden');
      });
    });
    var lightbox = root.querySelector('[data-quality-lightbox]');
    function closeLightbox() { lightbox.classList.add('pbnk-hidden'); lightbox.querySelector('img').removeAttribute('src'); }
    lightbox.addEventListener('click', function (event) { if (event.target === lightbox) closeLightbox(); });
    lightbox.querySelector('[data-quality-close]').addEventListener('click', closeLightbox);

    function optimize(file) {
      return new Promise(function (resolve) {
        if (!file || !/^image\/(jpeg|png|webp)$/i.test(file.type)) { resolve(file); return; }
        var image = new Image();
        var url = URL.createObjectURL(file);
        image.onload = function () {
          URL.revokeObjectURL(url);
          var scale = Math.min(1, 2200 / Math.max(image.naturalWidth, image.naturalHeight));
          if (scale === 1) { resolve(file); return; }
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(image.naturalWidth * scale);
          canvas.height = Math.round(image.naturalHeight * scale);
          canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(function (blob) {
            resolve(blob ? new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' }) : file);
          }, 'image/jpeg', .86);
        };
        image.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
        image.src = url;
      });
    }

    function showSuccess(data) {
      form.classList.add('pbnk-hidden');
      var success = root.querySelector('[data-success]');
      success.classList.remove('pbnk-hidden');
      root.querySelector('[data-reference]').textContent = copy.reference + ' ' + String(data.ticket_number || data.ticketNumber || 'received');
      window.requestAnimationFrame(function () {
        success.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }

    function wait(milliseconds) {
      return new Promise(function (resolve) { window.setTimeout(resolve, milliseconds); });
    }

    async function confirmSavedRequest() {
      if (!nonce || !nonce.value) return null;
      for (var attempt = 0; attempt < 4; attempt++) {
        if (attempt > 0) await wait(500 * attempt);
        try {
          var response = await fetch(api + '/api/requests/status?nonce=' + encodeURIComponent(nonce.value), {
            method: 'GET',
            cache: 'no-store'
          });
          if (!response.ok) continue;
          var data = await response.json();
          if (data && data.success && data.found) return data;
        } catch (statusError) {}
      }
      return null;
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var submit = form.querySelector('[type=submit]');
      var submitLabel = submit.querySelector('[data-submit-label]');
      var feedback = form.querySelector('[data-feedback]');
      feedback.className = 'pbnk-feedback pbnk-field--full';
      if (!checkEmails()) {
        feedback.textContent = copy.emailMismatch;
        feedback.classList.add('is-visible', 'is-error');
        return;
      }
      submit.disabled = true;
      form.inert = true;
      submitLabel.textContent = copy.uploading;
      try {
        var body = new FormData(form);
        var rows=Array.from(list.querySelectorAll('.pbnk-photo'));
        body.set('color_options_json',JSON.stringify(rows.map(function(row){return row.querySelector('[data-product]').value==='diamond'?[]:selectedColors(row);})));
        var capabilities=await fetch(api+'/api/requests/capabilities',{cache:'no-store'});
        if(!capabilities.ok || !(await capabilities.json()).multipleColorOptions) throw new Error(root.dataset.multiUpgrade||copy.submitError);
        var photos = body.getAll('photos[]');
        body.delete('photos[]');
        for (var i = 0; i < photos.length; i++) body.append('photos[]', await optimize(photos[i]));
        var response = await fetch(api + '/api/requests', { method: 'POST', body: body });
        var responseText = await response.text();
        var data = {};
        try { data = responseText ? JSON.parse(responseText) : {}; } catch (parseError) {}
        if (!response.ok || !data.success) throw new Error(data.error || copy.submitError);
        showSuccess(data);
      } catch (error) {
        var savedRequest = null;
        savedRequest = await confirmSavedRequest();
        if (savedRequest) {
          showSuccess(savedRequest);
        } else {
          feedback.textContent = error.message || copy.submitError;
          feedback.classList.add('is-visible', 'is-error');
        }
      } finally {
        form.inert = false;
        submit.disabled = false;
        submitLabel.textContent = copy.submit;
      }
    });
  });
})();
